import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, CardBody, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table, NavItem, Nav, NavLink } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import classNames from "classnames";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

//import action
import { getChartsData as onGetChartsData } from "../../store/actions";

// Image
import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import breadcrumbs from "common/Breadcrumbs";
import useApi from "common/ApiMiddlewere";
import toast from "react-hot-toast";
import IconComponent from "./IconComponent";
import { routes } from "routes/path";

const Dashboard = props => {

  const { getApi } = useApi()
  let { pathname } = useLocation()
  const navigate = useNavigate()
  const [screeLoad, setscreeLoad] = useState(true)
  const [dailyActivity, setdailyActivity] = useState(null)
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("authUser"))
  )

  useEffect(() => {
    getApi(`User/dashboard-widget`, "").then(({ data, status }) => {
      setscreeLoad(false);
      if (status === 200) {
        const aggregated = {};
        data.forEach(item => {
          const key = item.Key;
          if (!aggregated[key]) {
            aggregated[key] = {
              Key: key,
              DisplayName: item.DisplayName,
              Value: 0
            };
          }
          aggregated[key].Value += item.Value;
        });

        const result = Object.values(aggregated);
        let tempActivity = [];
        if (userData?.RoleName === "Admin") {
          result.forEach((dataItem) => {
            if (
              ((dataItem.Key !== "TodaysTask" && dataItem.Key !== "PendingTask" && dataItem.Key !== 'PendingLeaves'))) {
              tempActivity.push({
                Key: dataItem.Key,
                DisplayName: dataItem.DisplayName,
                Value: dataItem.Value,
              });
            }
          });
          setdailyActivity(tempActivity);
          // setdailyActivity(result);
        } else if (userData?.RoleName === "Master") {
          result.forEach((dataItem) => {
            if (
              ((dataItem.Key === "TodaysTask" || dataItem.Key === "PendingTask" || dataItem.Key === 'PendingLeaves'))) {
              tempActivity.push({
                Key: dataItem.Key,
                DisplayName: dataItem.DisplayName,
                Value: dataItem.Value,
              });
            }
          });
          setdailyActivity(tempActivity);
        }
        else {
          if (userData?.TaskTitleTypes != null) {
            const taskTypes = userData.TaskTitleTypes.split(",");
            result.forEach((dataItem) => {
              // Always show these 3 widgets
              const alwaysVisibleKeys = ["HelpNeeded", "AdditionalWork", "Improvement", "PendingLeaves"];
              if (
                (taskTypes.includes("1") && (dataItem.Key === "TodaysTask" || dataItem.Key === "PendingTask")) ||
                (taskTypes.includes("2") && dataItem.Key === "TotalActiveLead" || dataItem.Key === "TodaysLead" || dataItem.Key === "TodaysCall" || dataItem.Key === "TodaysFollowUp") ||
                (taskTypes.includes("4") &&
                  (dataItem.Key === "TotalAppointment" || dataItem.Key === "Todays Appointment")) ||
                alwaysVisibleKeys.includes(dataItem.Key) ||
                (taskTypes.includes("11") && (dataItem.Key == "Message1" || dataItem.Key == "Message2" || dataItem.Key == "Message3" || dataItem.Key == "Message4" || dataItem.Key == "Message5") || dataItem.Key == "Message6" || dataItem.Key == "Message7" || dataItem.Key == "Message8" || dataItem.Key == "Message9" || dataItem.Key == "CALL") || (taskTypes.includes("12") && (dataItem.Key == "CALL"))
              ) {
                tempActivity.push({
                  Key: dataItem.Key,
                  DisplayName: dataItem.DisplayName,
                  Value: dataItem.Value,
                });
              }
            });
          }
          setdailyActivity(tempActivity);
        }
      } else {
        setscreeLoad(false);
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        });
      }
    });
  }, [location.pathname === "/dashboard"]);

  const DashboardProperties = createSelector(
    (state) => state.Dashboard,
    (dashboard) => ({
      chartsData: dashboard.chartsData
    })
  );

  const {
    chartsData
  } = useSelector(DashboardProperties);


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
  }, [dispatch]);

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  //meta title
  document.title = "Dashboard | Raja Rani Couture ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {screeLoad && (
            <div className="loading-overlay is-active">
              <span className="fas fa-spinner fa-3x fa-spin"></span>
            </div>
          )}
          <Breadcrumbs
            title={breadcrumbs[pathname].title}
            breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          />
          {userData?.RoleName === "Admin" &&
            < Row >
              <Col md={12}>
                <Nav
                  tabs
                  className="nav-tabs-custom nav-justified"
                  style={{ padding: "2px 10px" }}
                >
                  <NavItem
                    onClick={() => {
                      toggleCustom("1")
                    }}
                  >
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classNames({
                        "active nav-link": customActiveTab === "1",
                      })}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-calendar-check"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Task Management
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem
                    onClick={() => {
                      toggleCustom("2")
                    }}
                  >
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classNames({
                        "active nav-link": customActiveTab === "2",
                      })}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-shopping-cart"></i>
                      </span>
                      <span className="d-none d-sm-block">Administrative</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>}
          <Row>
            <Col xl="12">
              <Row>
                {dailyActivity
                  ? dailyActivity.map((report, key) => (
                    <Col md="3" key={"_col_" + key}>
                      <Card>
                        <CardBody
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            {
                              report.Key == "TotalActiveLead"
                                ? navigate(routes.lead, {
                                  state: {
                                    Callus: 1,
                                  },
                                })
                                : report.Key == "TodaysLead"
                                  ? navigate(routes.lead, {
                                    state: {
                                      Call: true,
                                    },
                                  })
                                  : report.Key == "TodaysCall"
                                    ? navigate(routes.lead, {
                                      state: {
                                        Call: true,
                                      },
                                    })
                                    : report.Key == "TodaysFollowUp"
                                      ? navigate(routes.lead, {
                                        state: {
                                          Call: true,
                                          followup: true
                                        },
                                      })
                                      : report.Key == "TotalAppointment"
                                        ? navigate(routes.appointment, {
                                          state: {
                                            CallDisble: false,
                                          },
                                        })
                                        : report.Key == "TodaysTask"
                                          ? navigate(routes.task)
                                          : report.Key == "Todays Appointment"
                                            ? navigate(routes.appointment)
                                            : report.Key == "PendingTask"
                                              ? navigate(routes.task)
                                              : report.Key == "HelpNeeded"
                                                ? navigate(routes.helpNeeded)
                                                : report.Key == "AdditionalWork"
                                                  ? navigate(routes.additionalWork)
                                                  : report.Key == "Improvement"
                                                    ? navigate(routes.improvement)
                                                    : report.Key == "PendingLeaves"
                                                      ? navigate(routes.leave)
                                                      : report.Key == "Message1"
                                                        ? navigate(routes.rentmakinglist, {
                                                          state: {
                                                            Call: false,
                                                          },
                                                        })
                                                        : report.Key == "Message2"
                                                          ? navigate(routes.rentmakinglist, {
                                                            state: {
                                                              Call: false,
                                                            },
                                                          })
                                                          : report.Key == "Message3"
                                                            ? navigate(routes.rentmakinglist, {
                                                              state: {
                                                                Call: false,
                                                              },
                                                            })
                                                            : report.Key == "Message4"
                                                              ? navigate(routes.rentmakinglist, {
                                                                state: {
                                                                  Call: false,
                                                                },
                                                              })
                                                              : report.Key == "Message5"
                                                                ? navigate(routes.rentmakinglist, {
                                                                  state: {
                                                                    Call: false,
                                                                  },
                                                                })
                                                                : report.Key == "Message6"
                                                                  ? navigate(routes.rentmakinglist, {
                                                                    state: {
                                                                      Call: false,
                                                                    },
                                                                  })
                                                                  : report.Key == "Message7"
                                                                    ? navigate(routes.rentmakinglist, {
                                                                      state: {
                                                                        Call: false,
                                                                      },
                                                                    })
                                                                    : report.Key == "Message8"
                                                                      ? navigate(routes.rentmakinglist, {
                                                                        state: {
                                                                          Call: false,
                                                                        },
                                                                      })
                                                                      : report.Key == "Message9"
                                                                        ? navigate(routes.rentmakinglist, {
                                                                          state: {
                                                                            Call: false,
                                                                          },
                                                                        })
                                                                        : report.Key == "Message10"
                                                                          ? navigate(routes.rentmakinglist, {
                                                                            state: {
                                                                              Call: false,
                                                                            },
                                                                          })
                                                                          : report.Key == "CALL"
                                                                            ? navigate(routes.rentmakinglist, {
                                                                              state: {
                                                                                Call: true,
                                                                              },
                                                                            })
                                                                            : navigate(routes.dashboard)
                            }
                          }}
                        >
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.DisplayName}
                              </p>
                              <h4 className="mb-0">{report.Value}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span
                                className={`avatar-title rounded-circle`}
                              >
                                <IconComponent report={report} />
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                  : null}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
